import {
  ChatMessageAction,
  ChatMessageActionTypes,
  IMessage,
  Sender,
  ReactionItemType
} from './types';
import { INode } from './types';

const generateId = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

export const defaultState: IMessage[] = [
  {
    message_id: 'message-root',
    chatdata_id: '',
    type: Sender.OPERATOR,
    text: ''
  }
];
// export let chatBotBaseDataArray: INode[];
export default function chatMessageReducer(
  state = defaultState,
  action: ChatMessageActionTypes
) {
  switch (action.type) {
    case ChatMessageAction.FETCH_CHATBOT_DATA_SUCCESS: {
      let initialNode: INode[] = action.payload.chatbotData.filter(
        item => item.isRoot === true
      );
      return [
        {
          message_id: 'message-root',
          chatdata_id: initialNode[0].id,
          type: Sender.OPERATOR,
          text: initialNode[0].content
        }
      ];
    }
    case ChatMessageAction.START_CHATBOT:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: 'element-root',
          type: 'operator',
          text: action.payload.message
        }
      ];
    case ChatMessageAction.RETURN_ROOT_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `最初の質問に戻りますか？`,
          return_btn: true
        }
      ];
    case ChatMessageAction.RETURN_ROOT:
      // const rootNode: INode[] = chatBotBaseDataArray.filter(
      //   item => item.isRoot === true
      // );
      const rootNode = action.payload.data;

      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: rootNode.id,
          type: Sender.OPERATOR,
          text: rootNode.content
        }
      ];

    case ChatMessageAction.ADD_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: action.payload.id,
          type: action.payload.type,
          text: action.payload.text
        }
      ];

    case ChatMessageAction.REPLY_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: action.payload.id,
          type: action.payload.type,
          text: action.payload.text,
          like_btn:
            action.payload.reactionType === ReactionItemType.OPERATOR_ANSWER
              ? true
              : false
        }
      ];
    case ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST:
      const AnswerMessage = '回答を検索しています';
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `「${action.payload.message}」
					について${AnswerMessage}`
        }
      ];
    case ChatMessageAction.FETCH_KEYWORD_DATA_SUCCESS:
      return searchMessageDataIncludeKeywords(
        state,
        action.payload.keywords,
        action.payload.chatbasedata
      );

    case ChatMessageAction.FETCH_KEYWORD_DATA_FAILURE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `質問を受け取ることができませんでした。時間を置いてお試しください`
        }
      ];
    case ChatMessageAction.LOAD_CHATBOT_MESSAGE:
      return [...action.payload.data];
    default:
      return state;
  }
}

const searchMessageDataIncludeKeywords = (
  state: IMessage[],
  keywords: string[],
  chatbasedata: INode[]
) => {
  // キーワード検索のサーバーにエラーが出た時の対応
  // if (keywords.length > 0 && keywords[0] === "api_err_01") {
  // 	const rootNode: INode[] = chatBotBaseDataArray.filter(item => (
  // 		item.isRoot === true
  // 	));
  // 	const answerMessage = {
  // 		message_id: `element-${generateId()}`,
  // 		chatdata_id: `element-${generateId()}`,
  // 		type: Sender.OPERATOR,
  // 		text: "通信に失敗しました",
  // 	};
  // 	const resultMessage = [
  // 		{
  // 			message_id: `element-${generateId()}`,
  // 			chatdata_id: rootNode[0].id,
  // 			type: Sender.OPERATOR,
  // 			text: rootNode[0].content,
  // 		}
  // 	];
  // 	return ([
  // 		...state,
  // 		answerMessage,
  // 		...resultMessage
  // 	])
  // }

  // IE用のincludes polyfil
  // if (!Array.prototype.includes) {
  //   Object.defineProperty(Array.prototype, 'includes', {
  //     value: function(searchElement: any, fromIndex: number) {
  //       if (this == null) {
  //         throw new TypeError('"this" is null or not defined');
  //       }
  //       var o = Object(this);
  //       var len = o.length >>> 0;
  //       if (len === 0) {
  //         return false;
  //       }
  //       var n = fromIndex | 0;
  //       var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
  //       while (k < len) {
  //         if (o[k] === searchElement) {
  //           return true;
  //         }
  //         k++;
  //       }
  //       return false;
  //     }
  //   });
  // }

  // web, Webのようなパターンを同一にするため全部大文字で比較
  const uppserCaseKeywords = keywords.map(keyword => keyword.toUpperCase());

  // const chatBotBaseDataArray: INode[] = store.getState().chatBaseData;
  const chatBotBaseDataArray = chatbasedata;
  const searchData = chatBotBaseDataArray.filter(data => {
    if (typeof data.keyword !== 'undefined' && data.keyword.length > 0) {
      const filterData = data.keyword.filter(keyword => {
        if (uppserCaseKeywords.includes(keyword.toUpperCase())) {
          return data;
        }
        return null;
      });
      if (filterData.length > 0) return true;
    }
    return null;
  });

  let answerMessage: IMessage;
  let resultMessage: IMessage[];
  if (searchData.length > 0) {
    answerMessage = {
      message_id: `element-${generateId()}`,
      chatdata_id: `element-${generateId()}`,
      type: Sender.OPERATOR,
      text: '以下の回答が見つかりました'
    };
    resultMessage = searchData.map(data => ({
      message_id: `element-${generateId()}`,
      chatdata_id: data.id,
      type: Sender.OPERATOR,
      text: data.content
    }));
  } else {
    const rootNode: INode[] = chatBotBaseDataArray.filter(
      item => item.isRoot === true
    );
    answerMessage = {
      message_id: `element-${generateId()}`,
      chatdata_id: `element-${generateId()}`,
      type: Sender.OPERATOR,
      text: '回答を見つけることができませんでした'
    };
    resultMessage = [
      {
        message_id: `element-${generateId()}`,
        chatdata_id: rootNode[0].id,
        type: Sender.OPERATOR,
        text: rootNode[0].content
      }
    ];
  }

  return [...state, answerMessage, ...resultMessage];
};
